export const CHOOSE_CATEGORY_STYLE = {
  CARD_CATEGORY_SELECTOR: 'hover:shadow-light bg-action01 relative px-[4px] rounded-[4px] max-w-[90%]',
  CARD_CATEGORY_SELECTOR_TITLE:
    'font-metric text-action03 after:content-titleArrowDownIcon after:pl-[4px] text-[12px] py-[2px] px-[4px] truncate uppercase',
  CARD_CATEGORY_TT_WRAPPER: 'w-[300px] flex items-center justify-center',
  CARD_CATEGORY_TT_CONTENT: 'font-metric text-action03 text-[12px]',
  WRAPPERS: {
    SHARED:
      'max-w-[100%] flex justify-center items-center w-auto h-[24px] border-[1px] rounded-sm relative p-[6px] hover:shadow-light',
    PRE_SELECTED: 'bg-bw00 border-bw05',
    UNSELECTED: 'bg-action01 border-none',
    IS_BUSINESS: 'bg-bw00 border-action03',
    READ_ONLY: 'bg-bw05 border-none text-bw07',
  },
  TITLES: {
    SHARED: 'font-sourceSansPro text-sm uppercase tracking-normal truncate',
    PRE_SELECTED: 'border-bw05 text-bw05',
    UNSELECTED: 'text-action03',
    IS_BUSINESS: 'text-action03',
  },
  ARROWS: {
    SHARED: 'pl-[6px] w-[13px] h-[5px]',
    PRE_SELECTED: 'fill-bw05 ',
    UNSELECTED: 'fill-action03',
    IS_BUSINESS: 'fill-action03',
  },
};
